import { useEffect, type RefObject } from 'react';

/**
 * Fires `handler` when a mousedown lands outside `ref.current`. Used for
 * popover / menu dismiss behavior. No-op on the server.
 */
export function useOnClickOutside(
  ref: RefObject<HTMLElement | null>,
  handler: (event: MouseEvent) => void,
  enabled = true,
): void {
  useEffect(() => {
    if (!enabled) return;
    if (typeof document === 'undefined') return;
    const listener = (e: MouseEvent) => {
      const el = ref.current;
      if (!el) return;
      if (el.contains(e.target as Node)) return;
      handler(e);
    };
    document.addEventListener('mousedown', listener);
    return () => document.removeEventListener('mousedown', listener);
  }, [ref, handler, enabled]);
}
